// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import VueEcho from 'vue-echo';
import VueI18n from 'vue-i18n';
import Toasted from 'vue-toasted';
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import './assets/css/tarsius.css';
import messages from '@/assets/lang/messages';
import eruda from 'eruda';
import App from './App.vue';
import router from './router';
import store from './store';

// var confApiUrl = 'https://api.tarsius.nike.cust.telekom.sk/';
// var confWebsocketHost = 'https://api.tarsius.nike.cust.telekom.sk:6001';

const confApiUrl = ('$VUE_APP_TARSIUS_API_URL'[0] === '$') ? process.env.VUE_APP_TARSIUS_API_URL : '$VUE_APP_TARSIUS_API_URL';
const confWebsocketHost = ('$VUE_APP_TARSIUS_WEBSOCKET_URL'[0] === '$') ? process.env.VUE_APP_TARSIUS_WEBSOCKET_URL : '$VUE_APP_TARSIUS_WEBSOCKET_URL';
// import './registerServiceWorker';

window.axios = require('axios');
window.io = require('socket.io-client');

Vue.use(Vuetify, {
  theme: {
    primary: '#C2185B',
    secondary: '#455A64',
    accent: '#E91E63',
    error: '#F44336',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FF9800',
  },
  options: {
    customProperties: true,
  },
});
Vue.use(VueI18n);
Vue.use(Toasted);
Vue.use(CKEditor);

const accessToken = localStorage.getItem('access-token');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.api_url = confApiUrl;

if (accessToken) {
  window.axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}

Vue.use(VueEcho, {
  broadcaster: 'socket.io',
  host: confWebsocketHost,
  authEndpoint: '/broadcasting/auth',
  auth: {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  },
});

Vue.config.productionTip = false;

let locale = localStorage.getItem('locale');

if (!locale) {
  locale = 'en';
  localStorage.setItem('locale', 'en');
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages,
/* eslint-disable */
  pluralizationRules: {
  'sk': function (choice, choicesLength) {
          if (choicesLength == 4) {
              if (choice === 0) return 0;
              if (choice === 1) return 1;
              if (choice <= 4) return 2;
              return 3;
          }
          if (choicesLength == 2) {
             if (choice === 1) return 0;
             return 1;
          }
        },
  }
/* eslint-enable */
});

const loadedLanguages = ['en'];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  window.axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);

  return lang;
}

export default function loadLanguageAsync(lang) {
  let desiredLang = lang;
  if (lang === null || lang === '') desiredLang = 'en';
  if (i18n.locale !== desiredLang) {
    if (!loadedLanguages.includes(desiredLang)) {
      return import(`@/assets/lang/${desiredLang}`).then((msgs) => {
        i18n.setLocaleMessage(desiredLang, msgs.default);
        loadedLanguages.push(desiredLang);

        return setI18nLanguage(desiredLang);
      });
    }

    return Promise.resolve(setI18nLanguage(desiredLang));
  }

  return Promise.resolve(desiredLang);
}

if (localStorage.getItem('active-eruda')) {
  eruda.init();
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
});
